<script>
import { onMount } from 'svelte';
import * as user from '../user.js';
import * as utils from '../utils';
import { curUser } from '../user.js';
import { link, replace, querystring } from 'svelte-spa-router'
import firebase from '../firebase';
import qs from 'qs';
import AlternateHeader from './altheader.svelte';

onMount(() => { window.scrollTo(0,0); });


let email = '';

curUser.subscribe((u) =>
{
    utils.log("Verify current user loaded", u);
    if (u && u.auth)
        email = u.auth.email;
});


function ResendEmail()
{
    Alert('Email Sent. Check your inbox');
    user.SendEmailVerification();
}

</script>

<AlternateHeader/>

<!-- Section -->
<div class="container main medium" style="margin-top: 0;">
<section class="line-after">
  <header class="major center">
      <div class="image"><img src="images/whiteLogo.png" alt="" /></div>
  </header>
</section>
  <section>
    <header>
        <h5>Step 2 of 4</h5>
    </header>
    <div class="inner" style="border-left: .25rem solid #4a98e2; padding-left: 10px;">
        <h4>Verify your email address</h4>
        <p>We've sent an email to {email} to verify your email address. Please click on the link in that email to continue. If you don't see it in the next few minutes, check your spam folder.</p>
    </div>
    <div class="inner" style="border-left: .25rem solid #4a98e2; padding-left: 10px;">
        <h4>Having trouble?</h4>
        <p>Click <a href={"javascript:void(0)"} on:click={ResendEmail}>here to send another email</a>. If you're still having trouble verifying your email address <a href="/contact" use:link>contact us.</a></p>
    </div>
  </section>
</div>


<style>
@media screen and (max-width: 480px) {
  header.center {
    text-align: center;
}}

h5 {
  color: #c5c5c5 !important;
  font-weight:normal;
}

header.major { margin: 1em 0 0 0; }
.container > section.line-after:after {
  content: '';
  display: inline-block;
  width: 90%;
  height: 0.25rem;
  margin: 1em 5%;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}
.errorMsg
{
    color: red;
    text-align: left;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label, p {
  color: #fff !important;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 275px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 250px;
  }
}


ul.actions.special > li {
  width: 100%;
  margin: 0;
}

a {
    color: #4a98e2;
    border-bottom: 0;
}

/*a

.wrapper { padding: 0 20px; }

.wrapper > .main > header {
  text-align: left !important;
}

.wrapper, .wrapper > .main.alt {
  background-color: rgb(26, 30, 41) !important;
}

.wrapper > .main.alt {
  background-image: none;
  max-width: 600px;
  margin: 0 auto;
  padding: 0;
}

h2, h3, h4, h5, p { color: #fff; }
h4 {
  font-size: 1rem;
  text-transform: none;
  text-align: left;
}

h6 { color: #cacaca; }

p { text-align: left; }

ul.actions.special > li, li > .button.next { width: 100% !important; }

.image img { height: 4rem; }

.wrapper > .main > header:before {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    margin: 0;
    border-radius: 0px;
    background-color: #4a98e2;
}

@media screen and (max-width: 375px) {
  .wrapper > .main.alt.special {
    margin: 0px;
    width: 100%;
  }
}*/


</style>
